import { GET_SMS_RELOAD_HISTORY, GET_SMS_COUNT_REMAIN, GET_SMS_COUNT } from "./smsCountTypes";

export default {
  [GET_SMS_COUNT_REMAIN](state, data) {
    state.smsRemain = data;
  },
  [GET_SMS_RELOAD_HISTORY](state, data) {
    state.smsCountHistory = data;
  },
  [GET_SMS_COUNT](state, data) {
    state.smsCount = data;
  },
}
